import axios from "axios";
import { axiosArisChatInstance } from "../AxiosConfiguration";
import { chatArisApi } from "./Chat";


const ARIS_API_BASE_URL = process.env.REACT_APP_BASE_URL_CHAT_ARIS;
export const convertTextToSpeech = async (
  text,
  voice = "alloy",
  stream = false
) => {
  try {
    const response = await axios.get(`${ARIS_API_BASE_URL}/ARIS/tts`, {
      params: { text, voice, stream },
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("Text-to-speech conversion failed:", error);
    throw error;
  }
};

export const convertVoicetoName = async (audioFile, verification = false) => {
  try {
    const formData = new FormData();
    formData.append("file", audioFile);

    const response = await axios.post(
      `${ARIS_API_BASE_URL}/ARIS/voice-to-name`,
      formData,
      {
        params: { verification },
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "blob",
      }
    );

    const contentType = response.headers['content-type'];

    // ✅ CASE 1: API returned an error as JSON
    if (contentType && contentType.includes("application/json")) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      const error = new Error("Voice conversion failed");
      error.detail = json?.detail || "Unknown error from voice API";
      throw error;
    }

    // ✅ CASE 2: API returned valid audio blob
    return response.data; // This will be the Blob
  } catch (error) {
    console.error("Voice-to-name conversion failed:", error);
    throw error;
  }
};


export const chatCreateRelationShip = async (params) => {
  try {
    const response = await chatArisApi(null, params.query, null, "ONBOARDING_RELATIONSHIP", false, params, "relationship_add")
    return response.data;
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};

export const generateDomainElements = async (user_id, domain, query, session_id) => {
  try {
    ///ARIS/elements/chat/{user_id}/{domain}
    // const response = await axiosArisChatInstance.get(
    //   `ARIS/elements/${user_id}/${domain}`,
    //   {
    //     params: {
    //       query: query,
    //       callback_url:
    //         process.env.REACT_APP_BASE_URL_ASSESSMENT +
    //         "/api/status/fetch/user/elements",
    //     },
    //   }
    // );
    const response = await chatArisApi(user_id, query, session_id, "ELEMENTS", false, { "topic": domain })
    return response.response;
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};

export const domainElementsChat = async (user_id, domain, query, session_id) => {
  try {
    ///ARIS/elements/chat/{user_id}/{domain}
    const response = await chatArisApi(user_id, query, session_id, "ELEMENTS", false, { "topic": domain })
    return response.response;
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};

// export const encryptkeys = async () => {
//   try {
//     ///ARIS/elements/chat/{user_id}/{domain}
//     const response = await axiosArisChatInstance.post(
//       `ARIS/encrypt/voice?aws=true`,
//       {
//        aws:true
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error during API call:", error);
//     throw error;
//   }
// };
